/**
 * web/src/components/shared/RowCard.tsx
 * `.row-card` contract (design_files/styles.css lines 638-653) — used by
 * ApprovalQueue + Confirmations rows. Hover state: stronger border + soft
 * bg. Click target: the whole row (consumers attach onClick).
 */
import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/cn';

/** Public props for RowCard — div attributes. */
export interface RowCardProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}

/**
 * Hand-rolled RowCard primitive.
 * Side effects: none — pure styled wrapper. Consumers attach onClick to
 * the whole row; hover state telegraphs interactivity.
 */
export function RowCard({ className, children, ...props }: RowCardProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-3.5 bg-bg border border-border rounded-lg px-4 py-3.5 transition-colors duration-100',
        'hover:border-border-strong hover:bg-bg-soft cursor-pointer',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
